import { useEffect, useRef } from "react";

import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import WhatsappTemplateForm from "./WhatsappTemplateForm";

export default WhatsappMessageActionForm;

function WhatsappMessageActionForm(props) {
  const {
    errors,
    formState,
    setFormState,
    workspaceId,
    updateFormState,
    whatsappProvider,
    assistantOptions,
    phoneNumberOptions,
    evolutionConfiguration,
  } = props;

  const templateResetRef = useRef(false);

  useEffect(() => {
    if (!whatsappProvider || !templateResetRef.current) {
      templateResetRef.current = true;
      return;
    }

    if (whatsappProvider && templateResetRef.current) {
      setFormState((prev) => {
        return {
          ...prev,
          template: JSON.stringify({
            templateName: "",
            templateLanguage: "",
          }),
          attributes: {},
        };
      });
    }
  }, [whatsappProvider]);

  return (
    <div className="space-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          onChange={(e) => updateFormState("name", e.target.value)}
          invalid={!!errors.name}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          value={formState.description}
          rows={3}
          style={{ fontSize: "13px" }}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Assistant *</Label>
        <Listbox
          as="div"
          className="my-4"
          invalid={!!errors.assistantId}
          value={formState.assistantId}
          defaultValue={formState.assistantId}
          onChange={(value) => updateFormState("assistantId", value)}
        >
          {assistantOptions.map((assistant, idx) => {
            return (
              <ListboxOption
                key={idx}
                value={assistant.value}
              >
                <ListboxLabel>{assistant.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
        {errors.assistantId && (
          <ErrorMessage>{errors.assistantId}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>From Number *</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.fromIdentifier}
          invalid={!!errors.fromIdentifier}
          defaultValue={formState.fromIdentifier}
          onChange={(value) => updateFormState("fromIdentifier", value)}
        >
          {phoneNumberOptions.map((option, idx) => {
            return (
              <ListboxOption
                key={idx}
                value={option.value}
              >
                <ListboxLabel>{option.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
        {errors.fromIdentifier && (
          <ErrorMessage>{errors.fromIdentifier}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>Phone Number Field Mapping *</Label>
        <Input
          type="text"
          value={formState.phoneNumberField}
          onChange={(e) => updateFormState("phoneNumberField", e.target.value)}
          invalid={!!errors.phoneNumberField}
        />
        {errors.phoneNumberField && (
          <ErrorMessage>{errors.phoneNumberField}</ErrorMessage>
        )}
      </Field>

      <WhatsappTemplateForm
        errors={errors}
        formState={formState}
        workspaceId={workspaceId}
        updateFormState={updateFormState}
        activeWhatsappProvider={whatsappProvider}
        evolutionConfiguration={evolutionConfiguration}
      />
    </div>
  );
}
